module.exports = __webpack_public_path__ + "img/android.78b3f208.png";